const buildLayout = (selectType) => [
  {
    name: "Details",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1718616936763-col-1",
                elementid: "1718616984561",
                elementtype: selectType,
              },
            ],
            colpos: 1,
            parentid: "1718616936763-columns",
            elementid: "1718616936763-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616936763-col-2",
                elementid: "1718617038957",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1718616936763-columns",
            elementid: "1718616936763-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616936763",
        elementtype: "columns",
      },
      {
        child: [
          {
            child: [
              {
                parentid: "1718616939763-col-1",
                elementid: "1718616994627",
                elementtype: selectType,
              },
            ],
            colpos: 1,
            parentid: "1718616939763-columns",
            elementid: "1718616939763-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1718616939763-col-2",
                elementid: "1718617002793",
                elementtype: selectType,
              },
            ],
            colpos: 2,
            parentid: "1718616939763-columns",
            elementid: "1718616939763-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1718616917457-form",
        elementid: "1718616939763",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1718616917457",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];

// Create mode renders selects; edit mode renders the same slots as read-only
// text fields (see QuoteDetailsFieldsJSON).
export const QuoteDetailsLayoutJSON = buildLayout("customSelect");
export const QuoteEditDetailsLayoutJSON = buildLayout("textfield");
